var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4672 17.0163C16.9154 15.3981 17.8 13.2447 17.8 10.8841C17.8 10.4556 17.4593 10.1079 17.0371 10.1079C16.616 10.1079 16.2743 10.4556 16.2743 10.8841C16.2743 12.721 15.6287 14.4069 14.5574 15.7167L15.4672 17.0163ZM12.2246 17.6154C11.2251 18.1339 10.0953 18.4263 8.9 18.4263C4.83346 18.4263 1.52571 15.0422 1.52571 10.8841C1.52571 10.4556 1.18497 10.1079 0.762857 10.1079C0.34176 10.1079 0 10.4556 0 10.8841C0 15.6368 3.58557 19.5493 8.13785 19.9456L8.13714 22.4738C8.13714 22.9023 8.4789 23.25 8.9 23.25C9.3211 23.25 9.66286 22.9023 9.66286 22.4738L9.66317 19.9455C10.9042 19.8373 12.0734 19.4678 13.1176 18.8912L12.2246 17.6154ZM13.0287 13.5328C13.5134 12.7574 13.7945 11.8371 13.7945 10.8511V5.99952C13.7945 3.24259 11.5985 1 8.9 1C7.50363 1 6.2418 1.6005 5.34918 2.56204L6.25898 3.86175C6.87659 3.0645 7.83102 2.55233 8.9 2.55233C10.7573 2.55233 12.2688 4.09844 12.2688 5.99952V10.8511C12.2688 11.2961 12.1858 11.7218 12.0347 12.1128L13.0287 13.5328ZM9.81196 14.1688L10.7337 15.4855C10.167 15.7202 9.54801 15.8495 8.9 15.8495C6.20152 15.8495 4.00551 13.607 4.00551 10.8511V5.99952C4.00551 5.95823 4.006 5.91705 4.00698 5.876L5.53122 8.05348V10.8511C5.53122 12.7501 7.0427 14.2972 8.9 14.2972C9.21591 14.2972 9.5218 14.2525 9.81196 14.1688Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.20579,
    y1: 0.598576,
    x2: 16.7425,
    y2: 21.3652,
    stroke: "white",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAudio);
export default __webpack_public_path__ + "static/media/noAudio.2a6212949d550e73d1f7d0a171a260e6.svg";
export { ForwardRef as ReactComponent };